// extracted by mini-css-extract-plugin
export default {"MainDivSkeleton":"Loader_MainDivSkeleton__OTbLX"};